import React from "react";
import { LocalisedText } from "../../i18n";

import styles from "./style.module.scss";
import { CustomerOrderResponse } from "../../generated/graphql";

interface OrderDetailTitleProps {
  customerOrder: CustomerOrderResponse;
}

const OrderDetailTitle: React.FC<OrderDetailTitleProps> = (
  props: OrderDetailTitleProps
) => {
  const { customerOrder } = props;

  return (
    <div className={styles.title}>
      <span>
        <LocalisedText id="view.orderDetails.orderDetails" />
      </span>
      <span className={styles.orderId}>{`(#${customerOrder.order.id})`}</span>
    </div>
  );
};

export default OrderDetailTitle;
